import axiosConfig from '../../../../../config/axiosConfig';
import { Params } from '../../presenter/type/Presenter';

const CM0017_3_1Api = () => {
    const getReSummarySubmittedOutsourceCostOffsetList = async (params: Params): Promise<any> => {
        try {
            const url = '/re-summary/submitted/outsource-cost/offset/list';
            const response = await axiosConfig.get(url, { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    return {
        getReSummarySubmittedOutsourceCostOffsetList,
    };
};

export default CM0017_3_1Api;
